import { render, staticRenderFns } from "./DamageReportCreate.vue?vue&type=template&id=4effe475&"
import script from "./DamageReportCreate.vue?vue&type=script&lang=js&"
export * from "./DamageReportCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports